/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.f122n59{align-items:center;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.f1e5rei4{min-block-size:28px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
.f1s184ao{margin:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fqerorx{flex-grow:1;}
.fy9rknc{font-size:var(--fontSizeBase200);}
.fwrc4pm{line-height:var(--lineHeightBase200);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f1fciab8{letter-spacing:0.04em;}
.f1u78bsq{text-transform:uppercase;}
.f11d4kpn{color:var(--colorNeutralForeground3);}
.f1cd1ik7{min-inline-size:20px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1nqfz0o{padding-inline:6px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ewtqcl{box-sizing:border-box;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f44lkw9{border-radius:var(--borderRadiusCircular);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ac3ntu{background-color:var(--bfTrack);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
.f13mqy1h{font-size:var(--fontSizeBase100);}
.fwbovi1{line-height:18px;}
.f17mccla{text-align:center;}
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
.fgdu4nw{padding-inline:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fbi42co{row-gap:2px;}
.f10pi13n{position:relative;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.ff3ufwa{min-block-size:52px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f9b8bpc{padding-block:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fmm5bso{-webkit-padding-start:var(--spacingHorizontalM);padding-inline-start:var(--spacingHorizontalM);}
.fgcytg1{-webkit-padding-end:var(--spacingHorizontalS);padding-inline-end:var(--spacingHorizontalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f19n0e5{color:var(--colorNeutralForeground1);}
.fulqd5u{color:var(--bfSelectedForeground);}
.f1bgiulx{background-color:var(--bfSelectedBackground);}
.f1wl9k8s::before{content:"";}
.f1j7ml58::before{position:absolute;}
.f1d2slso::before{inset-inline-start:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f68jq20::before{inset-block:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fk1k89f::before{inline-size:3px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fielpny::before{border-radius:var(--borderRadiusCircular);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1jzd0na::before{background-color:var(--bfSelectedForeground);}
.fi64zpg{flex-shrink:0;}
.fuzgk9b{min-inline-size:0;}
.f1rvi9lw{display:-webkit-box;}
.f1h500bm{-webkit-line-clamp:2;}
.fi1h9r9{-webkit-box-orient:vertical;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1a3p1vp{overflow:hidden;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fjksvth{overflow-wrap:anywhere;}
.fkhj508{font-size:var(--fontSizeBase300);}
.f1i3iumi{line-height:var(--lineHeightBase300);}
.fni485r{flex-wrap:wrap;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.ftuwxu6{display:inline-flex;}
.fjgzulp{align-self:flex-start;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.f12ffk1x{min-block-size:36px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
/** @griffel:css-end **/
/** @griffel:css-start [h] null **/
.feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}
.f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}
.fbnuktb:hover{text-decoration-line:none;}
.f1p45l4d:hover{color:var(--bfSelectedForeground);}
.f1rlav19:hover{background-color:var(--bfSelectedBackgroundHover);}
/** @griffel:css-end **/